import { API } from '@/api/Api'

import { GetBankAnalysisAssumptions, EditBankAnalysisAssumptions, SaveBankAnalysisAssumptions, ListPastAnalyses, DeleteBankAnalysis, ExistsBankAnalysisByName, SetActiveBankAnalysis } from '@/api/query/InterestRate.graphql'

export default {
  async GetBankAnalysisAssumptions (accountId, analysisId) {
    const Data = { accountId: accountId, analysisId: analysisId }
    return await API.GQLRequest(GetBankAnalysisAssumptions, Data)
  },
  async EditBankAnalysisAssumptions (accountId, analysisId, analysisParameters) {
    const Data = { accountId: accountId, analysisId: analysisId, analysisParameters: analysisParameters }
    return await API.GQLRequest(EditBankAnalysisAssumptions, Data)
  },
  async SaveBankAnalysisAssumptions (accountId, analysisId, analysisName) {
    const Data = { accountId: accountId, analysisId: analysisId, analysisName: analysisName }
    return await API.GQLRequest(SaveBankAnalysisAssumptions, Data)
  },
  async SetActiveBankAnalysis (accountId, bankAnalysisId) {
    const Data = { accountId: accountId, bankAnalysisId: bankAnalysisId }
    return await API.GQLRequest(SetActiveBankAnalysis, Data)
  },
  async ListPastAnalyses (params) {
    const Data = { ...params }
    return await API.GQLRequest(ListPastAnalyses, Data)
  },
  async DeleteBankAnalysis (accountId, analysisId) {
    const Data = { accountId: accountId, analysisId: analysisId }
    return await API.GQLRequest(DeleteBankAnalysis, Data)
  },

  async ExistsBankAnalysisByName (accountId, name) {
    const Data = { accountId: accountId, name: name }
    return await API.GQLRequest(ExistsBankAnalysisByName, Data)
  }
}
